import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ChestCircumference extends PrimitiveValueObject<number> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: number): ChestCircumference {
    if (value < 0) {
      throw new Error('正数である必要があります');
    }
    return new ChestCircumference(value);
  }

  /** ラベル */
  static get label(): string {
    return '胸囲(cm)';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '10';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {};
  }

  /** キー */
  static get key() {
    return 'chestCircumference';
  }

  /** タイプ */
  static get type() {
    return 'number';
  }
}
